export default __webpack_public_path__ + "static/media/doctor-1.4c0efad4.PNG";